export class DisplayUtils {

    /**
     * セッションからdisplayModeを取得し値が1の場合falseを返却する
     * 1以外の場合tureを返す。
     */
    public static isDisplay(): boolean {
        return sessionStorage.getItem("displayMode") != "1" ;
    }

    /**
     * スマポアプリからの遷移モードか判定します。
     * セッションからdisplayModeを取得し値が1の場合trueを返却、1以外の場合falseを返します。
     * ※ displayModeが「1」か判定
     */
    public static isSmartphoneAppMode(): boolean {
        return sessionStorage.getItem("displayMode") === "1";
    }

    /**
     * BSECからの遷移モードか判定します。
     * セッションからdisplayModeを取得し値が2の場合trueを返却、2以外の場合falseを返します。
     * ※ displayModeが「2」か判定
     */
    public static isBsecMode(): boolean {
        return sessionStorage.getItem("displayMode") === "2";
    }
}